export const getAllDeliveries = "/deliveries";
export const getDeliveryById = "/delivery/{deliveryId}";
